"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ISurvey = require("./Api/ISurvey");
var SurveyStatCollection_1 = require("./SurveyStatCollection");
var Utils = require("./Utils");
/**
 * StatCollection for activated surveys.  Should be used to track the SurveyIds
 * that have been recently shown to a user
 */
// TODO (gachoi) Check if this applies - VSOBug: 1443010 One bad Stat object fails the entire serialization
var SurveyStatCollectionActivation = /** @class */ (function (_super) {
    __extends(SurveyStatCollectionActivation, _super);
    function SurveyStatCollectionActivation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Load from Json
     */
    SurveyStatCollectionActivation.fromJson = function (json) {
        var statCollection = new SurveyStatCollectionActivation();
        if (!json) {
            // TODO (gachoi) Log null json passed
            return statCollection;
        }
        var readStats;
        try {
            readStats = JSON.parse(json);
        }
        catch (e) {
            // TODO (gachoi) Log parsing failed
            return statCollection;
        }
        if (!statCollection.deserialize(readStats)) {
            return new SurveyStatCollectionActivation();
        }
        return statCollection;
    };
    /**
     * Convert to Json
     */
    SurveyStatCollectionActivation.toJson = function (object) {
        if (!object) {
            // TODO (gachoi) log that null object passed
            object = new SurveyStatCollectionActivation();
        }
        return JSON.stringify(object);
    };
    /**
     * Add another SurveyStatCollectionActivation object
     */
    SurveyStatCollectionActivation.prototype.accumulate = function (other) {
        if (!other) {
            return;
        }
        var stats = other.getStats();
        // SurveyActivationStats accumulation simply overwrites any keys from 'other' into our collection
        for (var key in stats) {
            if (stats.hasOwnProperty(key)) {
                this.addStats(key, stats[key]);
            }
        }
    };
    /**
     * Method to deserialize SurveyStatCollectionActivation
     * @param input: collection of SurveyStatCollectionActivation
     * Returns result of validation check
     */
    SurveyStatCollectionActivation.prototype.deserialize = function (input) {
        var rawStats = input.Surveys;
        var now = new Date();
        for (var key in rawStats) {
            if (rawStats.hasOwnProperty(key)) {
                var newStat = new SurveyActivationStats();
                if (newStat.deserialize(rawStats[key]) && newStat.ExpirationTimeUtc > now) {
                    this.addStats(key, newStat);
                }
            }
        }
        return this.validate();
    };
    /**
     * Validate the Surveys
     * Returns false if validation fails
     */
    SurveyStatCollectionActivation.prototype.validate = function () {
        return Utils.isObject(this.getStats());
    };
    return SurveyStatCollectionActivation;
}(SurveyStatCollection_1.SurveyStatCollection));
exports.SurveyStatCollectionActivation = SurveyStatCollectionActivation;
var SurveyActivationStats = /** @class */ (function () {
    function SurveyActivationStats() {
    }
    /**
     * Method to deserialize a JSON object to class object
     * @param input: JSON object
     * Returns result of validation check
     */
    SurveyActivationStats.prototype.deserialize = function (input) {
        this.ActivationTimeUtc = input.ActivationTimeUtc;
        this.ExpirationTimeUtc = input.ExpirationTimeUtc;
        this.Type = input.Type;
        return this.validate();
    };
    /**
     * Method to call after deserialization to validate generated object.
     * Returns false if not valid.
     */
    SurveyActivationStats.prototype.validate = function () {
        // make it a date object if it's a valid UTC date time value
        if (Utils.isUtcDatetimeString(this.ActivationTimeUtc)) {
            this.ActivationTimeUtc = Utils.stringToDate(this.ActivationTimeUtc);
        }
        else {
            return false;
        }
        // make it a date object if it's a valid UTC date time value
        if (Utils.isUtcDatetimeString(this.ExpirationTimeUtc)) {
            this.ExpirationTimeUtc = Utils.stringToDate(this.ExpirationTimeUtc);
        }
        else {
            return false;
        }
        return Utils.isEnumValue(this.Type, ISurvey.Type);
    };
    return SurveyActivationStats;
}());
exports.SurveyActivationStats = SurveyActivationStats;
